import "webrtc-adapter";

export const getBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("edg")) return "edge"; // Detects modern Edge (Chromium-based)
  if (userAgent.includes("opr") || userAgent.includes("opera")) return "opera"; // Opera
  if (userAgent.includes("firefox")) return "firefox"; // Firefox
  if (userAgent.includes("chrome") && !userAgent.includes("edg")) return "chrome"; // Chrome (excluding Edge)
  if (userAgent.includes("safari") && !userAgent.includes("chrome")) return "safari"; // Safari (excluding Chrome)

  return "unknown";
};
